import {
    ApiGetDashboardSummary,
    ApiGetDashboardChart,
    ApiGetDashboardDetail,
    ApiGetDashboardRekap,
    ApiGetDashboardKeuangan,
} from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function DashboardService() {
    const { showFail } = useModal()

    const { fetch: apiGetDashboardSummary } = useFetch(ApiGetDashboardSummary)
    const { fetch: apiGetDashboardChart } = useFetch(ApiGetDashboardChart)
    const { fetch: apiGetDashboardDetail } = useFetch(ApiGetDashboardDetail)
    const { fetch: apiGetDashboardRekap } = useFetch(ApiGetDashboardRekap)
    const { fetch: apiGetDashboardKeuangan } = useFetch(ApiGetDashboardKeuangan)

    // Row 1 - summary cards
    const fetchDashboardSummary = async (periode, startDate, endDate) => {
        const res = await apiGetDashboardSummary({
            data: {
                periode,
                startDate,
                endDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Row 2 - charts
    const fetchDashboardChart = async (periode, startDate, endDate) => {
        const res = await apiGetDashboardChart({
            data: {
                periode,
                startDate,
                endDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Row 3 - detail tables
    const fetchDashboardDetail = async (periode, startDate, endDate) => {
        const res = await apiGetDashboardDetail({
            data: {
                periode,
                startDate,
                endDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Row 4 - recap section
    const fetchDashboardRekap = async (periode, startDate, endDate) => {
        const res = await apiGetDashboardRekap({
            data: {
                periode,
                startDate,
                endDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Row 5 - finance section
    const fetchDashboardKeuangan = async (periode, startDate, endDate) => {
        const res = await apiGetDashboardKeuangan({
            data: {
                periode,
                startDate,
                endDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchDashboardSummary,
        fetchDashboardChart,
        fetchDashboardDetail,
        fetchDashboardRekap,
        fetchDashboardKeuangan,
    }
}